import { AppList } from "fleet/view/application/list";
import { connect } from "react-redux";
import {
  applicationsSelector,
  installedAppsSelector,
} from "redux-store/applications/selectors";
import { makeGetAllAsArray } from "redux-store/selectors";
import { storesReady } from "redux-store/utils";

const getAllAppsAsArray = makeGetAllAsArray();

function mapStateToProps(state) {
  const storesLoaded = storesReady(state.global.applications);
  const appById = applicationsSelector(state);
  const apps = getAllAppsAsArray({ byId: appById });
  const installedApps = installedAppsSelector(apps);

  return {
    storesLoaded,
    apps: installedApps,
    title: "Your Apps",
  };
}

const ConnectedInstalledAppsListPage = connect(mapStateToProps)(AppList);

export { ConnectedInstalledAppsListPage };
